export const POPUP_CONTENT: IMassMailingPopupContent[] = [];
